module.exports = __webpack_public_path__ + "static/img/bg.4f8dd98f.jpg";